<div class="app-version">
  v{{version}}<ng-container *ngIf="feBuild">.{{feBuild}}</ng-container> | API v{{apiVersion}}
</div>